<footer
    class="footer-area text-center bg-white border-top-radius"
    [class.card-borderd-theme]="themeService.isCardBorder()"
    [class.component-dark-theme]="themeService.isDark()"
>
    <p>
        © <span class="text-black fw-medium">Općine</span> Created by Codestream Consulting j.d.o.o.<a href="/" target="_blank"></a>
    </p>
</footer>